const bliss = {
    name: "Bliss 2",
    files: [
        { weight: 400, style: "normal", file: "bliss2-v1/bliss2r.woff2", format: "woff2" },
        { weight: 500, style: "normal", file: "bliss2-v1/bliss2m.woff2", format: "woff2" },
        { weight: 700, style: "normal", file: "bliss2-v1/bliss2b.woff2", format: "woff2" },
    ],
};
const firaSans = {
    name: "Fira Sans",
    files: [
        {
            weight: 100,
            style: "normal",
            file: "fira-v1/firasans-hair.woff2",
            format: "woff2",
        },
        {
            weight: 100,
            style: "italic",
            file: "fira-v1/firasans-hairitalic.woff2",
            format: "woff2",
        },
        {
            weight: 200,
            style: "normal",
            file: "fira-v1/firasans-ultralight.woff2",
            format: "woff2",
        },
        {
            weight: 200,
            style: "italic",
            file: "fira-v1/firasans-ultralightitalic.woff2",
            format: "woff2",
        },
        {
            weight: 300,
            style: "normal",
            file: "fira-v1/firasans-light.woff2",
            format: "woff2",
        },
        {
            weight: 300,
            style: "italic",
            file: "fira-v1/firasans-lightitalic.woff2",
            format: "woff2",
        },
        {
            weight: 400,
            style: "normal",
            file: "fira-v1/firasans-regular.woff2",
            format: "woff2",
        },
        {
            weight: 400,
            style: "italic",
            file: "fira-v1/firasans-italic.woff2",
            format: "woff2",
        },
        {
            weight: 500,
            style: "normal",
            file: "fira-v1/firasans-medium.woff2",
            format: "woff2",
        },
        {
            weight: 500,
            style: "italic",
            file: "fira-v1/firasans-mediumitalic.woff2",
            format: "woff2",
        },
        {
            weight: 600,
            style: "normal",
            file: "fira-v1/firasans-semibold.woff2",
            format: "woff2",
        },
        {
            weight: 600,
            style: "italic",
            file: "fira-v1/firasans-semibolditalic.woff2",
            format: "woff2",
        },
        {
            weight: 700,
            style: "normal",
            file: "fira-v1/firasans-bold.woff2",
            format: "woff2",
        },
        {
            weight: 700,
            style: "italic",
            file: "fira-v1/firasans-bolditalic.woff2",
            format: "woff2",
        },
        {
            weight: 800,
            style: "normal",
            file: "fira-v1/firasans-extrabold.woff2",
            format: "woff2",
        },
        {
            weight: 800,
            style: "italic",
            file: "fira-v1/firasans-extrabolditalic.woff2",
            format: "woff2",
        },
        {
            weight: 900,
            style: "normal",
            file: "fira-v1/firasans-heavy.woff2",
            format: "woff2",
        },
        {
            weight: 900,
            style: "italic",
            file: "fira-v1/firasans-heavyitalic.woff2",
            format: "woff2",
        },
    ],
};
const inter = {
    name: "Inter",
    files: [
        { weight: "100 900", style: "normal", file: "inter-v1/intervariable.woff2", format: "woff2" },
        { weight: "100 900", style: "italic", file: "inter-v1/intervariable-italic.woff2", format: "woff2" },
    ],
};
const nhJuniorPen = {
    name: "NH Junior Pen",
    files: [
        {
            weight: 400,
            style: "normal",
            file: "nhjuniorpen-v1/nhjuniorpen.woff2",
            format: "woff2",
        },
    ],
};
const nunito = {
    name: "Nunito",
    files: [
        {
            weight: "100 1000",
            style: "normal",
            file: "nunito-v1/nunito-latin-variable-wghtonly-normal.woff2",
            format: "woff2",
        },
        {
            weight: "100 1000",
            style: "italic",
            file: "nunito-v1/nunito-latin-variable-wghtonly-italic.woff2",
            format: "woff2",
        },
    ],
};
const openSans = {
    name: "Open Sans",
    files: [
        {
            weight: "100 1000",
            style: "normal",
            file: "open-sans-v1/open-sans-latin-variable-full-normal.woff2",
            format: "woff2",
        },
        {
            weight: "100 1000",
            style: "italic",
            file: "open-sans-v1/open-sans-latin-variable-full-italic.woff2",
            format: "woff2",
        },
    ],
};
const poppins = {
    name: "Poppins",
    files: [
        { weight: 100, style: "normal", file: "poppins-v1/poppins-thin.woff2", format: "woff2" },
        { weight: 200, style: "normal", file: "poppins-v1/poppins-extralight.woff2", format: "woff2" },
        { weight: 300, style: "normal", file: "poppins-v1/poppins-light.woff2", format: "woff2" },
        { weight: 400, style: "normal", file: "poppins-v1/poppins-regular.woff2", format: "woff2" },
        { weight: 500, style: "normal", file: "poppins-v1/poppins-medium.woff2", format: "woff2" },
        { weight: 600, style: "normal", file: "poppins-v1/poppins-semibold.woff2", format: "woff2" },
        { weight: 700, style: "normal", file: "poppins-v1/poppins-bold.woff2", format: "woff2" },
        { weight: 800, style: "normal", file: "poppins-v1/poppins-extrabold.woff2", format: "woff2" },
        { weight: 900, style: "normal", file: "poppins-v1/poppins-black.woff2", format: "woff2" },
    ],
};
const roboto = {
    name: "Roboto",
    files: [
        { weight: 100, style: "normal", file: "roboto-v1/roboto-thin-webfont.woff", format: "woff" },
        { weight: 100, style: "italic", file: "roboto-v1/roboto-thinitalic-webfont.woff", format: "woff" },
        { weight: 300, style: "normal", file: "roboto-v1/roboto-light-webfont.woff", format: "woff" },
        { weight: 300, style: "italic", file: "roboto-v1/roboto-lightitalic-webfont.woff", format: "woff" },
        { weight: 400, style: "normal", file: "roboto-v1/roboto-regular-webfont.woff", format: "woff" },
        { weight: 400, style: "italic", file: "roboto-v1/roboto-italic-webfont.woff", format: "woff" },
        { weight: 500, style: "normal", file: "roboto-v1/roboto-medium-webfont.woff", format: "woff" },
        { weight: 500, style: "italic", file: "roboto-v1/roboto-mediumitalic-webfont.woff", format: "woff" },
        { weight: 700, style: "normal", file: "roboto-v1/roboto-bold-webfont.woff", format: "woff" },
        { weight: 700, style: "italic", file: "roboto-v1/roboto-bolditalic-webfont.woff", format: "woff" },
        { weight: 900, style: "normal", file: "roboto-v1/roboto-black-webfont.woff", format: "woff" },
        { weight: 900, style: "italic", file: "roboto-v1/roboto-blackitalic-webfont.woff", format: "woff" },
    ],
};
export const fonts = [bliss, firaSans, inter, nhJuniorPen, nunito, openSans, poppins, roboto];
